import AbstractLanguage from './AbstractLanguage';

export default class Payout extends AbstractLanguage {
  get next_payout() {
    return this.getText({
      EN: 'Next payout',
      RU: 'Следующая выплата',
      UA: 'Наступна виплата',
    });
  }

  get salary() {
    return this.getText({
      EN: 'Salary',
      RU: 'Зарплата',
      UA: 'Зарплата',
    });
  }

  get salary_history() {
    return this.getText({
      EN: 'Salary history',
      RU: 'История зарплаты',
      UA: 'Історія зарплати',
    });
  }

  get current_salary() {
    return this.getText({
      EN: 'Current salary',
      RU: 'Текущая зарплата',
      UA: 'Поточна зарплата',
    });
  }

  get not_set() {
    return this.getText({
      EN: 'Not set',
      RU: 'Не задана',
      UA: 'Не задана',
    });
  }

  get change_salary() {
    return this.getText({
      EN: 'Change salary',
      RU: 'Изменить зарплату',
      UA: 'Змінити зарплату',
    });
  }

  get quick_actions() {
    return this.getText({
      EN: 'Quick actions',
      RU: 'Быстрые действия',
      UA: 'Швидкі дії',
    });
  }

  get new_amount() {
    return this.getText({
      EN: 'New amount',
      RU: 'Новая сумма',
      UA: 'Нова сума',
    });
  }

  get expenses() {
    return this.getText({
      EN: 'Expenses',
      RU: 'Расходы',
      UA: 'Витрати',
    });
  }

  get add_expense() {
    return this.getText({
      EN: 'Add expense',
      RU: 'Добавить расход',
      UA: 'Додати витрату',
    });
  }

  get no_expenses() {
    return this.getText({
      EN: 'No expenses yet',
      RU: 'Расходов пока нет',
      UA: 'Витрат поки немає',
    });
  }

  get total() {
    return this.getText({
      EN: 'Total',
      RU: 'Итого',
      UA: 'Разом',
    });
  }

  get repeats_monthly() {
    return this.getText({
      EN: 'Repeats monthly',
      RU: 'Повторяется ежемесячно',
      UA: 'Повторюється щомісяця',
    });
  }

  get added_by_employee() {
    return this.getText({
      EN: 'Added by employee',
      RU: 'Добавлено сотрудником',
      UA: 'Додано співробітником',
    });
  }

  get excluded_by_admin() {
    return this.getText({
      EN: 'Excluded by admin',
      RU: 'Исключено админом',
      UA: 'Виключено адміном',
    });
  }

  get moved_to() {
    return this.getText({
      EN: 'Moved to',
      RU: 'Перенесено на',
      UA: 'Перенесено на',
    });
  }

  get moved_from() {
    return this.getText({
      EN: 'Moved from',
      RU: 'Перенесено с',
      UA: 'Перенесено з',
    });
  }

  get defer() {
    return this.getText({
      EN: 'Move to next payout',
      RU: 'Перенести на следующую выплату',
      UA: 'Перенести на наступну виплату',
    });
  }

  get exclude() {
    return this.getText({
      EN: 'Exclude',
      RU: 'Исключить',
      UA: 'Виключити',
    });
  }

  get restore() {
    return this.getText({
      EN: 'Restore',
      RU: 'Вернуть',
      UA: 'Повернути',
    });
  }

  get stop_recurring() {
    return this.getText({
      EN: 'Stop repeating',
      RU: 'Прекратить повтор',
      UA: 'Припинити повтор',
    });
  }

  get search_expenses() {
    return this.getText({
      EN: 'Search or type a new one',
      RU: 'Найдите или введите новый',
      UA: 'Знайдіть або введіть новий',
    });
  }

  get recently_used() {
    return this.getText({
      EN: 'Recently used',
      RU: 'Недавние',
      UA: 'Нещодавні',
    });
  }

  get amount() {
    return this.getText({
      EN: 'Amount',
      RU: 'Сумма',
      UA: 'Сума',
    });
  }

  get repeat_every_month() {
    return this.getText({
      EN: 'Repeat every month',
      RU: 'Повторять каждый месяц',
      UA: 'Повторювати щомісяця',
    });
  }

  get paid_history() {
    return this.getText({
      EN: 'Paid history',
      RU: 'История выплат',
      UA: 'Історія виплат',
    });
  }

  get imported_note() {
    return this.getText({
      EN: 'Carried over from the accounting sheet',
      RU: 'Перенесено из бухгалтерской таблицы',
      UA: 'Перенесено з бухгалтерської таблиці',
    });
  }

  get save() {
    return this.getText({
      EN: 'Save',
      RU: 'Сохранить',
      UA: 'Зберегти',
    });
  }

  get payouts() {
    return this.getText({
      EN: 'Payouts',
      RU: 'Выплаты',
      UA: 'Виплати',
    });
  }

  get months() {
    return this.getText({
      EN: 'months',
      RU: 'мес.',
      UA: 'міс.',
    });
  }

  get recorded() {
    return this.getText({
      EN: 'Paid',
      RU: 'Выплачено',
      UA: 'Виплачено',
    });
  }

  get projected() {
    return this.getText({
      EN: 'Projected',
      RU: 'Прогноз',
      UA: 'Прогноз',
    });
  }

  get archived() {
    return this.getText({
      EN: 'Archived',
      RU: 'В архиве',
      UA: 'В архіві',
    });
  }

  get person_column() {
    return this.getText({
      EN: 'Person',
      RU: 'Сотрудник',
      UA: 'Співробітник',
    });
  }

  get people() {
    return this.getText({
      EN: 'people',
      RU: 'чел.',
      UA: 'осіб',
    });
  }

  get review_salary() {
    return this.getText({
      EN: 'Review salary',
      RU: 'Пересмотреть зарплату',
      UA: 'Переглянути зарплату',
    });
  }

  get all_months() {
    return this.getText({
      EN: 'All months',
      RU: 'Все месяцы',
      UA: 'Усі місяці',
    });
  }

  get show_archived() {
    return this.getText({
      EN: 'Archived',
      RU: 'Архив',
      UA: 'Архів',
    });
  }

  get add_contractor() {
    return this.getText({
      EN: '+ Contractor',
      RU: '+ Подрядчик',
      UA: '+ Підрядник',
    });
  }

  get contractor_name() {
    return this.getText({
      EN: 'Name',
      RU: 'Имя',
      UA: "Ім'я",
    });
  }

  get add() {
    return this.getText({
      EN: 'Add',
      RU: 'Добавить',
      UA: 'Додати',
    });
  }

  get salary_and_payout() {
    return this.getText({
      EN: 'Salary & payout',
      RU: 'Зарплата и выплата',
      UA: 'Зарплата та виплата',
    });
  }

  get show_unpaid() {
    return this.getText({
      EN: 'Unpaid',
      RU: 'Без выплат',
      UA: 'Без виплат',
    });
  }

  get archive() {
    return this.getText({
      EN: 'Archive contractor',
      RU: 'В архив',
      UA: 'До архіву',
    });
  }

  get contractor() {
    return this.getText({
      EN: 'Contractor',
      RU: 'Подрядчик',
      UA: 'Підрядник',
    });
  }

  get contractors() {
    return this.getText({
      EN: 'Contractors',
      RU: 'Подрядчики',
      UA: 'Підрядники',
    });
  }

  get payment_details() {
    return this.getText({
      EN: 'Payment details',
      RU: 'Платёжные реквизиты',
      UA: 'Платіжні реквізити',
    });
  }

  get add_payment_details() {
    return this.getText({
      EN: 'Add payment details',
      RU: 'Добавить реквизиты',
      UA: 'Додати реквізити',
    });
  }

  get edit_payment_details() {
    return this.getText({
      EN: 'Edit payment details',
      RU: 'Изменить реквизиты',
      UA: 'Змінити реквізити',
    });
  }

  get no_payment_details() {
    return this.getText({
      EN: 'No payment details yet',
      RU: 'Реквизитов пока нет',
      UA: 'Реквізитів поки немає',
    });
  }

  get copy() {
    return this.getText({
      EN: 'Copy',
      RU: 'Копировать',
      UA: 'Копіювати',
    });
  }

  get copied() {
    return this.getText({
      EN: 'Copied',
      RU: 'Скопировано',
      UA: 'Скопійовано',
    });
  }

  get remove() {
    return this.getText({
      EN: 'Remove',
      RU: 'Удалить',
      UA: 'Видалити',
    });
  }

  get tap_again_to_remove() {
    return this.getText({
      EN: 'Tap again to remove',
      RU: 'Нажмите ещё раз, чтобы удалить',
      UA: 'Натисніть ще раз, щоб видалити',
    });
  }

  get requisite_name() {
    return this.getText({
      EN: 'Name',
      RU: 'Имя',
      UA: "Ім'я",
    });
  }

  get requisite_name_hint() {
    return this.getText({
      EN: 'Account holder, as the bank has it',
      RU: 'Владелец счёта, как в банке',
      UA: 'Власник рахунку, як у банку',
    });
  }

  get requisite_iban() {
    return this.getText({
      EN: 'IBAN',
      RU: 'IBAN',
      UA: 'IBAN',
    });
  }

  get requisite_swift() {
    return this.getText({
      EN: 'SWIFT',
      RU: 'SWIFT',
      UA: 'SWIFT',
    });
  }

  get requisite_country() {
    return this.getText({
      EN: 'Country',
      RU: 'Страна',
      UA: 'Країна',
    });
  }

  get requisite_country_hint() {
    return this.getText({
      EN: 'Country of the bank',
      RU: 'Страна банка',
      UA: 'Країна банку',
    });
  }

  get edit() {
    return this.getText({
      EN: 'Edit',
      RU: 'Изменить',
      UA: 'Змінити',
    });
  }

  get proof() {
    return this.getText({
      EN: 'Proof',
      RU: 'Подтверждение',
      UA: 'Підтвердження',
    });
  }

  get proof_optional() {
    return this.getText({
      EN: 'Proof (optional)',
      RU: 'Подтверждение (необязательно)',
      UA: 'Підтвердження (необовʼязково)',
    });
  }

  get screenshot_or_file() {
    return this.getText({
      EN: 'Add screenshot or file',
      RU: 'Добавить скриншот или файл',
      UA: 'Додати скриншот або файл',
    });
  }

  get attach() {
    return this.getText({
      EN: 'Attach',
      RU: 'Добавить',
      UA: 'Додати',
    });
  }

  get uploading() {
    return this.getText({
      EN: 'Uploading…',
      RU: 'Загрузка…',
      UA: 'Завантаження…',
    });
  }

  get remove_file_confirm() {
    return this.getText({
      EN: 'Remove this file?',
      RU: 'Удалить этот файл?',
      UA: 'Видалити цей файл?',
    });
  }

  get attachment_wrong_type() {
    return this.getText({
      EN: 'Only images and PDFs can be attached',
      RU: 'Можно прикрепить только изображения и PDF',
      UA: 'Можна додати лише зображення та PDF',
    });
  }

  get attachment_too_big() {
    return this.getText({
      EN: 'Each file must be under 10 MB',
      RU: 'Каждый файл должен быть меньше 10 МБ',
      UA: 'Кожен файл має бути меншим за 10 МБ',
    });
  }

  get attachment_too_many() {
    return this.getText({
      EN: 'Up to 10 files at a time',
      RU: 'Не больше 10 файлов за раз',
      UA: 'Не більше 10 файлів за раз',
    });
  }

  get attachment_failed() {
    return this.getText({
      EN: 'Could not load this file',
      RU: 'Не удалось загрузить файл',
      UA: 'Не вдалося завантажити файл',
    });
  }

  get open_file() {
    return this.getText({
      EN: 'Open',
      RU: 'Открыть',
      UA: 'Відкрити',
    });
  }

  get no_preview() {
    return this.getText({
      EN: 'No preview in this browser — download to view',
      RU: 'Нет предпросмотра в этом браузере — скачайте файл',
      UA: 'Немає попереднього перегляду в цьому браузері — завантажте файл',
    });
  }

  get download() {
    return this.getText({
      EN: 'Download',
      RU: 'Скачать',
      UA: 'Завантажити',
    });
  }
}
